'use client';

import { Analytics } from 'Shared/utils/client';
import { Icon, Share } from '@viewup/ui';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { ShareModal } from './ShareModal';

export const ShareContentButton = () => {
  const pathname = usePathname();
  const [isOpenShareModal, setIsOpenShareModal] = useState(false);
  return (
    <>
      <Icon
        css={{ cursor: 'pointer' }}
        onClick={() => {
          Analytics.getInstance().track('SHARE', {
            pageName: pathname.split('/')[1],
          });
          setIsOpenShareModal(true);
        }}
        size='XS'
        source={Share}
      />
      {isOpenShareModal && <ShareModal exitHandler={() => setIsOpenShareModal(false)} />}
    </>
  );
};
